import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
    agentWalletConfigurationContent: {
      borderRadius: '12px',
      border: '1px solid #EAECF0',
      background: theme.palette.background.primary,
      boxShadow: theme.shadows[1],
      display: 'flex',
      padding: '24px 32px',
      flexDirection: 'column',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
    },
    headerWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '10px',
      marginBottom: '32px',
      marginTop: '20px',
    },
    Header: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    title: {
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: '28px',
      color: theme.palette.text.primary,
      width: '100%',
    },
    divider: {
      width: '100%',
      height: '1px',
      backgroundColor: theme.palette.divider,
      margin: '20px 0',
    },
    line: {
      width: '77%',
      height: '1px',
      backgroundColor: theme.palette.divider,
      margin: '20px 0',
    },
    section: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      width: '100%',
    },
    inputWithMargin: {
      marginBottom: '24px !important',
    },
    filedContainer: {
      display: 'flex',
      gap: '32px',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    subLabel: {
      color: theme.palette.text.tertiary,
      fontFamily: 'Inter',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      width: '280px',
    },
    label: {
      color: theme.palette.text.secondary,
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '20px',
    },
    filedWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '16px',
    },
    Standard: {
      '& .FBFieldWrapper': {
        display: 'flex',
        flexDirection: 'column !important',
        gap: '6px !important',
      },
    },
    helperText: {
      color: theme.palette.text.tertiary,
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 400,
    },
    buttonWrapper: {
      display: 'flex',
      gap: '12px',
    },
    wrapperInput: {
      '& .text-field-wrapper > div ': {
        [theme.breakpoints.down('sm')]: {
          width: '100% !important',
        },
      },
    },
  };
});
